<template>
  <div>
    <div class="search">
      <el-form label-width="80px" size="small">
        <el-row :gutter="20">
          <el-col span="5">
            <el-form-item label="项目名称">
              <el-select
                v-model="projectId"
                placeholder="请选择"
                @change="projectChange"
              >
                <el-option
                  v-for="(item, index) in projectList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="5">
            <el-form-item label="周期">
              <el-date-picker
                v-model="year"
                type="year"
                placeholder="请选择"
                @change="dateChange"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="container">
      <div class="grid"><div id="cost" class="echarts"></div></div>
      <div class="grid"><div id="income" class="echarts"></div></div>
      <div class="grid grid-flex">
        <div id="clinicalSatisfaction" class="echarts-half"></div>
        <div id="patientsSatisfaction" class="echarts-half"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getValueAnalysis,
  getCostEvaluation,
  getCreateIncome,
  getSatisfaction,
} from "@/api/crmedical/statistics/index";
import dayjs from "dayjs";
import {
  options_2,
  opt_income,
  opt_clinical_satisfaction,
  opt_patients_satisfaction,
} from "./options";
import { getProjectList } from "@/api/crmedical/project/project";
export default {
  data() {
    return {
      projectId: "",
      projectList: [],
      year: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  created() {
    this.period = dayjs().format("YYYY");
    this.year = dayjs().toDate();
  },
  async mounted() {
    let res = await getProjectList();
    this.projectList = res.data;
    this.projectId = res.data[0].id;
    this.generateCharts();
  },
  methods: {
    //项目改变
    projectChange(v) {
      this.generateCharts();
    },
    //年份改变
    dateChange(v) {
      //后端需要的数据格式
      this.period = dayjs(v).format("YYYY");
      //前端需要的数据格式
      this.year = dayjs(v).toDate();
      this.generateCharts();
    },
    //生成图表方法
    async generateCharts() {
      let params = {
        period: this.period,
        projectId: this.projectId,
      };
      // 满意度
      let res2 = await getSatisfaction(params);
      if (res2.data.length) {
        let data = res2.data[0];
        let clinicalEvaluationBase = data.clinicalEvaluationBase;
        let clinicalEvaluation = data.clinicalEvaluation;
        let clinicalBottomLine = 5;
        let patientSatisfactionBase = data.patientSatisfactionBase;
        let patientSatisfaction = data.patientSatisfaction;
        let patientlBottomLine = 5;
        // 临床满意度
        let c_text_0 = "";
        let c_color = "";
        if (clinicalEvaluation < clinicalBottomLine) {
          c_text_0 = "差";
          c_color = "red";
        } else if (clinicalEvaluation < clinicalEvaluationBase) {
          c_text_0 = "中";
          c_color = "orange";
        } else {
          c_text_0 = "优";
          c_color = "green";
        }
        opt_clinical_satisfaction.graphic.elements[0].style.text = c_text_0;
        opt_clinical_satisfaction.graphic.elements[0].style.fill = c_color;
        opt_clinical_satisfaction.graphic.elements[1].style.text =
          clinicalEvaluation + "%";
        opt_clinical_satisfaction.graphic.elements[1].style.fill = c_color;
        opt_clinical_satisfaction.series[0].data[0].value = clinicalEvaluation;
        opt_clinical_satisfaction.series[0].axisLabel.formatter = function (v) {
          if (v == clinicalBottomLine || v == clinicalEvaluationBase) {
            return v + "%";
          }
        };
        opt_clinical_satisfaction.series[0].axisLine.lineStyle.color = [
          [clinicalBottomLine / 100, "red"],
          [clinicalEvaluationBase / 100, "orange"],
          [1, "green"],
        ];
        echarts
          .init(document.getElementById("clinicalSatisfaction"))
          .setOption(opt_clinical_satisfaction);
        // 患者满意度
        let p_text_0 = "";
        let p_color = "";
        if (patientSatisfaction < patientlBottomLine) {
          p_text_0 = "差";
          p_color = "red";
        } else if (patientSatisfaction < patientSatisfactionBase) {
          p_text_0 = "中";
          p_color = "orange";
        } else {
          p_text_0 = "优";
          p_color = "green";
        }
        opt_patients_satisfaction.graphic.elements[0].style.text = p_text_0;
        opt_patients_satisfaction.graphic.elements[0].style.fill = p_color;
        opt_patients_satisfaction.graphic.elements[1].style.text =
          patientSatisfaction + "%";
        opt_patients_satisfaction.graphic.elements[1].style.fill = p_color;
        opt_patients_satisfaction.series[0].data[0].value = patientSatisfaction;
        opt_patients_satisfaction.series[0].axisLabel.formatter = function (v) {
          if (v == patientlBottomLine || v == patientSatisfactionBase) {
            return v + "%";
          }
        };
        opt_patients_satisfaction.series[0].axisLine.lineStyle.color = [
          [patientlBottomLine / 100, "red"],
          [patientSatisfactionBase / 100, "orange"],
          [1, "green"],
        ];
        echarts
          .init(document.getElementById("patientsSatisfaction"))
          .setOption(opt_patients_satisfaction);
      }

      // 成本评价
      let res3 = await getCostEvaluation({ period: this.period });
      if (res3.data && res3.data.length > 0) {
        let seriesData = [];
        let xAxis = [];
        res3.data.forEach((element) => {
          seriesData.push(element.sumCost / 10000);
          xAxis.push(element.projectName);
        });
        options_2.xAxis.data = xAxis;
        options_2.series[0].data = seriesData;
        echarts.init(document.getElementById("cost")).setOption(options_2);
      }
      //创收
      let res4 = await getCreateIncome({ period: this.period });
      console.log("res4==>", res4);
      if (res4.data && res4.data.length > 0) {
        let data_4 = [];
        let legendData = [];
        let sumIncome = 0;
        res4.data.forEach((element) => {
          let item = {
            name: element.projectName,
            value: element.sumCreateIncome / 10000,
          };
          sumIncome+=Number(element.sumCreateIncome);
          data_4.push(item);
          legendData.push(element.projectName);
        });
        opt_income.legend.data = legendData;
        // opt_income.graphic.elements[0].style.text = sumIncome/10000;
        opt_income.graphic.elements[0].style.text = 100;
        opt_income.series[0].data = data_4;
        echarts.init(document.getElementById("income")).setOption(opt_income);
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.search{
  padding-top: 20px;
}
.container {
  display: flex;
  justify-content: space-between;
  align-content: flex-start;
  flex-wrap: wrap;
  padding: 20px;
  box-sizing: border-box;
}

.grid {
  width: calc(50% - 10px);
  margin-bottom:20px;
  border: 1px solid #efefef;
  background-color: #fff;
  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.06);
  padding: 20px;
}
.grid-flex {
  display: flex;
  align-items: center;
}
.echarts {
  width: 100%;
  height: 400px;
}
.echarts-half {
  width: 50%;
  height: 400px;
}
</style>